import { Handshake, ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { goToEnquiryAs } from "@/components/EnquiryForm";

// Generic dealer-only enquiry modal (no fleet wording — see DealerStickyBar
// for why) shared by any page that just needs a simple "become a dealer"
// path. `productLabel` fills in what they'd be a dealer for.
export const BecomeADealerModal = ({ open, onOpenChange, productLabel, testId }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid={testId} className="max-w-lg bg-[var(--bg-secondary)] border-[var(--border-default)] text-white">
      <DialogHeader>
        <div className="w-11 h-11 flex items-center justify-center border border-[var(--brand-primary)] bg-[var(--brand-primary)]/15 mb-2">
          <Handshake size={20} className="text-[var(--brand-primary)]" />
        </div>
        <DialogTitle className="font-display text-2xl text-white">Become A Dealer</DialogTitle>
        <DialogDescription className="text-base text-[var(--text-secondary)] leading-relaxed">
          Want to become a dealer for our {productLabel}? We'd love to hear from you — get in
          touch below and tell us a bit about what you need.
        </DialogDescription>
      </DialogHeader>
      <button
        type="button"
        data-testid={`${testId}-cta`}
        onClick={() => {
          onOpenChange(false);
          goToEnquiryAs("Dealer / Trade / Fleet Enquiry");
        }}
        className="btn-primary justify-self-start"
      >
        Get In Touch <ArrowUpRight size={14} />
      </button>
    </DialogContent>
  </Dialog>
);
